import * as API from "utils/api"
import HTTPStatus from "http-status"

const getSearchRequest = () => ({
  type: "GET_SEARCH_REQUEST",
})

const getSearchSuccess = search => ({
  type: "GET_SEARCH_SUCCESS",
  search,
})

const getSearchFailure = () => ({
  type: "GET_SEARCH_FAILURE",
})

export const getSearchResults = (countyId, search) => async dispatch => {
  dispatch(getSearchRequest())
  const response = await API.get(`/search?countyId=${countyId}&searchValue=${search}`)
  switch (response.status) {
    case HTTPStatus.OK:
      const searchResult = await response.json()
      dispatch(getSearchSuccess(searchResult))
      break

    default:
      dispatch(getSearchFailure())
  }
}


// WEBPACK FOOTER //
// src/data/search/actions.js